import { defineStore } from 'pinia';
import { ref } from 'vue';
import { login } from '@/api/auth';
import { useRouter } from 'vue-router';

interface User {
  id: number;
  name: string;
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null);
  const isAdmin = ref(false); // Can be tied to roles later or inherently true if valid token exists
  const loading = ref(true);

  const initAuth = () => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');

    if (token && savedUser) {
      try {
        user.value = JSON.parse(savedUser);
        isAdmin.value = true; // Assuming all logged-in users are admins for now
      } catch (e) {
        console.error('Failed to parse user from local storage');
        signOut();
      }
    }
    loading.value = false;
  };

  const signIn = async (account: string, rawPassword: string) => {
    try {
      const res = await login(account, rawPassword);

      if (res.success && res.data) {
        const { token, userId, name } = res.data;
        localStorage.setItem('token', token);
        const userInfo = { id: userId, name };
        localStorage.setItem('user', JSON.stringify(userInfo));
        
        user.value = userInfo;
        isAdmin.value = true;
        return { error: null };
      } else {
        return { error: res.message || 'Login failed' };
      }
    } catch (err: any) {
      return { error: err.message || 'Network error occurred during login' };
    }
  };

  const signOut = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    user.value = null;
    isAdmin.value = false;
  };

  return {
    user,
    isAdmin,
    loading,
    initAuth,
    signIn,
    signOut
  };
});
